import { Box, Grid, List, Typography, Button } from "@mui/material";
import React from "react";

function About() {
  return (
    <section id="about">
      <Typography
        variant="h2"
        className="caveatFont"
        sx={{ color: "#778A24", mt: 10, textAlign: "center" }}
      >
        About Us
      </Typography>

      <Grid
        container
        className="layoutMargin"
        sx={{ my: 10, px: { lg: 0, xs: "20px" } }}
      >
        {/* IMAGE SECTION */}
        <Grid lg={6} xs={12} item>
          <Box
            sx={{
              minHeight: { lg: "350px", xs: "auto" },
              height: "100%",
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              component="img"
              src="/assets/mainImage.png"
              alt="ગુજકો મોલ - ચેરમેનનો મેસેજ"
              className="imgResAbout"
              sx={{
                width: "100%",
                maxWidth: { lg: "380px", xs: "100%" },
                height: "auto",
                maxHeight: { lg: "500px", xs: "400px" },
                objectFit: "contain",
                objectPosition: "center",
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
                display: "block",
              }}
            />
          </Box>
        </Grid>

        {/* TEXT SECTION */}
        <Grid
          lg={6}
          xs={12}
          item
          sx={{
            paddingLeft: { lg: "0px", xs: 0 },
            position: "relative",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignContent: "center",
            height: "auto",
            textAlign: "start",
            marginTop: "0px",
          }}
        >
          <Typography
            variant="h2"
            className="caveatFont"
            sx={{ color: "#778A24", mt: 0, pb: 2, fontSize: "2.75rem" }}
          >
            Chairman's Message
          </Typography>
          <Typography variant="h3">ગુજકો મોલ</Typography>
          <Typography
            variant="body2"
            sx={{ margin: "20px 0px", textAlign: "justify" }}
          >
            સહકારીતાના માધ્યમથી ખેડૂતો જ નહીં ગામડા સ્વાવલંબી બનાવવાના જીવનમંત્ર સાથે અનેકવિધ સહકારી સંસ્થાઓમાં ખેડૂતો અને પશુપાલકોનું પ્રતિનિધિત્વ કરનાર ખેડૂતપુત્ર શ્રી ડૉ. (માનદ) તેજશ બી. પટેલ ઉર્ફે જીગાભાઇ સહકારી ક્ષેત્રે નીત નવા સાહસ ખેડીને રોજગારીનું સર્જન કરવા સાથે સહકારીતાના સારથિ બની રહ્યા છે. ભારતના લોકલાડીલા વડાપ્રધાન શ્રી નરેન્દ્રભાઇ મોદી, કેન્દ્રીય ગૃહ અને સહકાર મંત્રી શ્રી અમિતભાઇ શાહના સહકારથી સમૃદ્ધિના સંકલ્પને સાકાર કરવા શ્રી ડૉ. (માનદ) તેજશ બી. પટેલ દ્વારા આધુનિક સુવિધાઓ સાથે ગામડાઓ સ્વાવલંબી બને અને છેવાડાના માનવીઓને શહેરો જેવી સુવિધા પ્રાપ્ત થાય તે દિશામાં કાર્યો કરવામાં આવ્યા છે. ખેડૂતો ખેતી કરવા સાથે કૃષિ ઉત્પાદનોનું મૂલ્યવર્ધન કરીને માર્કેટિંગ કરવા સાથે વેચાણ કરી શકે તે માટે ગુજરાત સ્ટેટ કો.ઓપરેટિવ માર્કેટિંગ ફેડરેશન લિ.-ગુજકોમાસોલ દ્વારા બાંધણી ચોકડી ખાતે ત્રિભુવનદાસ પટેલ એસ્ટેટ ખાતે ગુજ્કો મોલનો વર્ષ ૨૦૧૮માં પ્રારંભ કરવામાં આવ્યો.
          </Typography>
          <Typography
            variant="body2"
            sx={{ margin: "10px 0px", textAlign: "justify" }}
          >
            ગુજકોમાસોલના ડિરેક્ટર ડૉ. (માનદ) તેજશ બી. પટેલ ઉર્ફે જીગાભાઇએ જણાવ્યું કે ખેડૂતો ખેતીમાં તનતોડ મહેનત કરીને મેળવતા કૃષિ ઉપજના પોષણક્ષમ ભાવ મળી રહે તે જરૂરી છે. જેથી માટે કૃષિ ઉપજોનું મૂલ્યવર્ધન કરવા સાથે માર્કેટિંગ ખાસ આવશ્યક છે. ઇઝરાયલ જેવા દેશમાં ૯૫ ટકા કૃષિ ઉપજોનું માર્કેટિંગ થાય છે. ખેડૂતો ખેતરમાં પાક લે ત્યારે તેઓની ખબર હોતી નથી કે કૃષિ ઉપજના શું ભાવ મળશે, જેથી ખેડૂતો કૃષિ ઉપજ કે પાકની ગુણવત્તાને લઇને હજી ખાસ ગંભીરતા દાખવતા નથી એટલે ગુણવત્તા બાબતે ધ્યાન આપતા નથી. જો ખેડૂતોને ખબર હોય કે સારા ગુણવત્તાયુક્ત કૃષિ ઉત્પાદન હશે તો આટલો ભાવ મળશે તો વધુ મહેનત કરવા સાથે ગુણવત્તા બાબતે પણ વિશેષ કાળજી રાખશે. જેથી ગુજકોમાસોલ દ્વારા આણંદ કૃષિ યુનિવર્સિટી સાથે એમઓયુ કરવામાં આવ્યા છે. જેથી કૃષિ યુનિવર્સિટીના તજ્જ્ઞોના માર્ગદર્શન હેઠળ ખેડૂતો દ્વારા ખેતી કરવામાં આવે અને જે કંઇ ખેતી પાક કે કૃષિ ઉપજ મળે તેમાં મૂલ્યવર્ધન કરીને બજારમાં વેચાણ અર્થે મુકવામાં આવે છે. એમાંય ખાસ કરીને એક્સપોર્ટ થઇ શકે તેવા સારી ગુણવત્તાવાળા કૃષિ ઉત્પાદનો માટે વિશેષ કાળજી લેવામાં આવશે. જેમાં કોન્ટ્રાક્ટ પદ્ધતિથી એડવાન્સમાં કૃષિ ઉપજના ભાવ પણ નક્કી થઇ જાય તેવી વ્યવસ્થા ઉભી કરવામાં આવી રહી છે. જેથી ખેડૂતો પાસેથી સીધા જ કૃષિ ઉત્પાદનો ખરીદી કરીને મૂલ્યવર્ધન કરવામાં આવતાં અને બજારમાં વેચાણ માટે મુકવામાં આવતાં વચેટીયાનો નફો નીકળી જશે, જેનો સીધો ફાયદો ખેડૂતોને થશે. આ ઉપરાંત ગુજકો મોલમાં ગુજકોમાસોલ દ્વારા ખેતી માટે બિયારણ, ખાતર અને દવાઓ પણ ખેડૂતોને મળી રહેશે.
          </Typography>
          <Typography
            variant="body2"
            sx={{ margin: "10px 0px", textAlign: "justify" }}
          >
            ગુજ્કો મોલમાં કેસર કેરી, અનાજ, સહકારી ધોરણે તૈયાર થતાં અથાણાં, પાપડ, પાપડી, ટોમેટો કેચઅપ, શક્તિવર્ધક પીણાં, અમૂલના ડેરી ઉત્પાદનો, કેરી, હર્બલ કોસ્મેટીક્સ, પીનટ્સ બટર સહિત કરિયાણાંની વિવિધ વસ્તુઓ મળી રહેશે. આ ઉપરાંત ખેડૂતોને ખેતી માટે જરૂરી બિયારણ, જંતુનાશક દવાઓ વગેરે પણ મળી રહે છે. જેથી ખેડૂતો એક જ સ્થળેથી પોતાના ઘરની જરૂરિયાતની વસ્તુઓ સાથે ખેતી માટે જરૂરી બિયારણ અને જંતુનાશક દવાઓ ખરીદી શકે તેવી વિશેષ વ્યવસ્થા ઉભી કરવામાં આવી છે.
          </Typography>
          <Button
            variant="contained"
            href="#contact"
            sx={{
              backgroundColor: "#778A24",
              color: "#fff",
              borderRadius: "25px",
              px: 4,
              py: 1,
              mt: 2,
              alignSelf: "flex-start",
              "&:hover": { backgroundColor: "#5e6d1c", color: "white" },
            }}
          >
            Contact Us
          </Button>
        </Grid>
      </Grid>
    </section>
  );
}

export default About;
